import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import EzRadioMui from "./Implementations/EzRadioMui.es.js";
const EzRadio = forwardRef(
  ({
    ariaLabel,
    checked,
    color = "primary",
    disabled = false,
    name = "radio-button",
    onChange,
    size = "medium",
    value,
    variant = "outlined"
  }, ref) => {
    return /* @__PURE__ */ jsx(
      EzRadioMui,
      {
        ref,
        ariaLabel,
        checked,
        color,
        disabled,
        name,
        onChange,
        size,
        value,
        variant
      }
    );
  }
);
EzRadio.displayName = "EzRadio";
export {
  EzRadio as default
};
//# sourceMappingURL=EzRadio.es.js.map
